import { render, staticRenderFns } from "./form-folder-update.vue?vue&type=template&id=0990a09d&"
import script from "./form-folder-update.vue?vue&type=script&lang=js&"
export * from "./form-folder-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports